import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { useKeycloak } from '@react-keycloak/web';

const LoginPage: React.FC = () => {
  const location = useLocation<{ [key: string]: unknown }>();
  const currentLocationState = location.state || {
    from: { pathname: '/meus-prontuarios' },
  };

  const { keycloak } = useKeycloak();

  const login = useCallback(() => {
    keycloak?.login();
  }, [keycloak]);

  useEffect(() => {
    if (!keycloak.authenticated) {
      login();
    }
  }, [keycloak, login]);

  if (keycloak?.authenticated)
    return <Redirect to={currentLocationState?.from as string} />;

  return <div />;
};

export default LoginPage;
